var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-menu"},[_c('a',{on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.title))]),(_vm.active)?_c('div',{staticClass:"dropdown-items-wrapper"},[_vm._l((_vm.items),function(ref){
var text = ref.text;
var link = ref.link;
var children = ref.children;
var classes = ref.classes;
return [(!link)?_c('h5',{key:text,staticClass:"dropdown-item"},[_vm._v("\n        "+_vm._s(text)+"\n      ")]):_vm._e(),(link)?_c('a',{key:text,class:['dropdown-item' ].concat( classes),attrs:{"href":_vm.generateLink(link)}},[_vm._v("\n        "+_vm._s(text)+"\n      ")]):_vm._e(),_vm._l((children),function(ref){
var text = ref.text;
var link = ref.link;
var classes = ref.classes;
return _c('a',{key:text,class:['dropdown-item' ].concat( classes),attrs:{"href":_vm.generateLink(link)}},[_vm._v("\n        "+_vm._s(text)+"\n      ")])}),(children)?_c('div',{key:text,staticClass:"divider"}):_vm._e()]})],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }